<template>
  <div class="wrapper">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="$router.back()" class="breadcrumb-item-back">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <el-form class="form-style" :model="form" size="mini" :inline="true">
        <el-form-item label="试题类型:">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option value="" label="全部"></el-option>
            <el-option value="1" label="单选题"></el-option>
            <el-option value="2" label="多选题"></el-option>
            <el-option value="3" label="判断题"></el-option>
            <el-option value="4" label="填空题"></el-option>
            <el-option value="5" label="简单题"></el-option>
            <el-option value="6" label="综合题"></el-option>
            <el-option value="9" label="编程题"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="试题名称:" prop="title">
          <el-input style="width: 200px" v-model="form.question_title" placeholder="请输入名称" clearable @keyup.enter.native="getSchoolQuestionList"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="getSchoolQuestionList">搜索</el-button>
          <el-button class="search_btn" type="primary" size="mini" @click="AddQuestion">添加试题</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="questions">
      <el-table size="mini" @expand-change="expandChange" :data="questionlist" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
        <el-table-column type="expand">
          <template slot-scope="props">
            <div style="padding:10px 20px;">
              <div v-if="props.row.show_type === 1">
                <div class="question_title" v-html="props.row.title"></div>
              </div>
              <div class="question_title" v-else>
                <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>
              <!-- 区分type=9编程题 -->
              <template v-if="props.row.type == 9">
                <!-- show_type=1 是editor =2是md -->
                <div class="question-body" style="padding-top:10px;margin-bottom:20px;font-size:16px">
                  <template v-if="props.row.ojProblemInfo.description_show_type === 1">
                    <div class="desc">
                      <strong style="display: inline-block;width:100%">描述</strong>
                      <span v-html="props.row.ojProblemInfo.description"></span>
                    </div>
                    <div class="desc-input" style="margin-bottom:10px;">
                      <strong>输入描述</strong>
                      <p v-html="props.row.ojProblemInfo.input_description"></p>
                    </div>
                    <div class="desc-output" style="margin-bottom:10px;">
                      <strong>输出描述</strong>
                      <p v-html="props.row.ojProblemInfo.output_description"></p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="desc">
                      <strong style="display: inline-block;width:100%">描述</strong>
                      <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="props.row.ojProblemInfo.md_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                    <div class="desc-input" style="margin-bottom:10px;">
                      <strong>输入描述</strong>
                      <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="props.row.ojProblemInfo.md_input_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                    <div class="desc-output" style="margin-bottom:10px;">
                      <strong>输出描述</strong>
                      <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="props.row.ojProblemInfo.md_output_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                  </template>
                  <div class="input-samples" style="margin-bottom:10px;">
                    <div v-for="(sample, i) in JSON.parse(props.row.ojProblemInfo.samples)" :key="i">
                      <strong class="title">输入样例 {{ i + 1 }}</strong>
                      <!-- <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags" :data-clipboard-text="sample.input" @click="copyText" size="mini">复制</el-tag></span> -->
                      <pre class="language-c" style="border:1px solid #ddd;padding:10px;border-radius:5px;margin-top:5px">{{ sample.input }}</pre>
                    </div>
                  </div>
                  <div class="output-samples" style="margin-bottom:10px;">
                    <div v-for="(sample, i) in JSON.parse(props.row.ojProblemInfo.samples)" :key="i">
                      <strong class="title">输出样例 {{ i + 1 }}</strong>
                      <!-- <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags" :data-clipboard-text="sample.output" @click="copyText" size="mini">复制</el-tag></span> -->
                      <pre class="language-c" style="border:1px solid #ddd;padding:10px;border-radius:5px;margin-top:5px">{{ sample.output }}</pre>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="props.row.show_type === 1">
                  <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                    <div v-if="props.row.type != '6'">
                      <div v-if="item.content" class="options_title">
                        {{ item.title }}、
                      </div>

                      <div v-if="item.content" class="options_content">
                        <div class="content" v-html="item.content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="props.row.type == '3'">
                    <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                      <div v-if="item.content" class="options_title">
                        {{ item.title }}、
                      </div>

                      <div v-if="item.content" class="options_content">
                        <div class="content" v-html="item.content"></div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="options" v-for="(item, index) of JSON.parse(props.row.options_md)" :key="index">
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}、
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content">
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div class="answer" v-if="props.row.type!=9">
                <span class="answer_label">正确答案:</span>
                <span v-if="
                  props.row.type == '1' ||
                    props.row.type == '2' ||
                    props.row.type == '3' ||
                    props.row.type == '4'
                " class="answer_content" v-html="props.row.answer"></span>
                <span v-else-if="props.row.type == '5'">简答题答案</span>
                <span v-else-if="props.row.type == '6'">综合题答案</span>
                <!-- <span v-else-if="props.row.type == '9'">编程题答案</span> -->
              </div>

              <div class="analysis">
                <span class="analysis_label">试题解析:</span>
                <template v-if="props.row.type == 9">
                  <el-button type="primary" size="small" style="margin-left:10px" round @click="handleProgrammingProblemDrawer(true,props.row)">查看解析</el-button>
                  <el-drawer title="试题解析" :with-header="false" size="100%" :visible.sync="programmingProblemShow" :direction="'ltr'">
                    <div class="analyze-content">
                      <div class="analyze-header">
                        <el-button icon="el-icon-back" style="backgroundColor:#4C95FC;border:none;color:#fff" @click="handleProgrammingProblemDrawer(false)">返回</el-button>
                      </div>
                      <div class="analyze-body" v-if="analyzeList.join('')!==''">
                        <div class="analyze-left">
                          <div v-for="anItem in analyzeList" :key="anItem.id" @click="handleSelectedAnalyzeItem(anItem)" :class="{'analyze-left-item':true, active:analyzeItem.id===anItem.id}">
                            <div class="title">
                              <img :src="anItem.headImg||'https://wugecdn.steam.fun/resources/static/images/logo.png'" alt="">
                              <strong>{{anItem.title}}</strong>
                              <span v-if="anItem.sort_type<3"><el-tag size="mini" effect="dark" :type="anItem.sort_type === 2?'success':''">{{anItem.sort_type === 1 ?"官方":anItem.sort_type === 2?'精选':''}}</el-tag></span>
                            </div>
                            <div class="content" v-html="anItem.content.replace(/<.+?>/g,'')"></div>
                          </div>
                          <div class="pagination">
                            <el-pagination @current-change="handleChangePage" :current-page.sync="analyzePage.page_no" layout="total, prev, pager, next" :page-size="analyzePage.page_size" :total="analyzePage.total"></el-pagination>
                          </div>
                        </div>
                        <div class="analyze-right" v-if="analyzeItem">
                          <div class="title">{{analyzeItem.title}}</div>
                          <div class="stu-info">
                            <img :src="analyzeItem.headImg|| 'https://wugecdn.steam.fun/resources/static/images/logo.png'" alt="">
                            <span>{{analyzeItem.realname||'格小C'}}</span>
                            <span>发布于: {{analyzeItem.update_time}}</span>
                          </div>
                          <div style="margin-bottom:20px">
                            <span v-if="analyzeItem.sort_type<3"><el-tag size="mini" effect="dark" :type="analyzeItem.sort_type === 2?'success':''">{{analyzeItem.sort_type === 1 ?"官方":analyzeItem.sort_type === 2 ?'精选':''}}</el-tag></span>
                            <span v-for="tagItem in analyzeItem.problemTagArr" :key="tagItem.id">
                              <el-tag type="info" size="mini" style="margin-left: 10px;">{{ tagItem.tagInfo.title }}</el-tag>
                            </span>
                            <span v-for="langItem in JSON.parse(analyzeItem.languages||'[]')" :key="langItem.id">
                              <el-tag type="info" size="mini" style="margin-left: 10px;">
                                {{langItem === '0'?'C':langItem==='1'?'C++':langItem==='2'?'Python3':''}}
                              </el-tag>
                            </span>
                          </div>
                          <!-- <CodeMirrorComponent v-if="analyzeItem" v-model="analyzeItem.content" /> -->
                          <!-- 解析视频 -->
                          <div class="video-box" v-if="analyzeItem.video_url_arr">
                            <div class="title" v-if="JSON.parse(analyzeItem.video_url_arr).length > 0">
                              <svg t="1724310100931" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3404" width="28" height="28">
                                <path d="M849.170732 0c97.404878 0 174.829268 77.42439 174.829268 174.829268v674.341464c0 97.404878-77.42439 174.829268-174.829268 174.829268H174.829268c-97.404878 0-174.829268-77.42439-174.829268-174.829268V174.829268c0-97.404878 77.42439-174.829268 174.829268-174.829268h674.341464z m-239.765854 299.707317H252.253659c-27.473171 0-49.95122 19.980488-52.448781 47.453659V691.82439c0 27.473171 19.980488 49.95122 47.453659 52.448781h362.146341c27.473171 0 49.95122-19.980488 52.448781-47.453659v-27.473171L699.317073 699.317073c14.985366 12.487805 37.463415 14.985366 54.946342 4.995122 17.482927-7.492683 27.473171-24.97561 27.47317-42.458536v-274.731708c0-19.980488-9.990244-37.463415-29.970731-44.956097-17.482927-7.492683-34.965854-7.492683-49.95122 2.497561l-2.497561 2.497561-39.960975 29.970731V349.658537c0-27.473171-19.980488-49.95122-47.453659-52.448781l-2.497561 2.497561z m-244.760976 137.365854c4.995122-2.497561 9.990244-2.497561 14.985366 0l2.497561 2.497561 104.897561 69.931707c4.995122 2.497561 7.492683 7.492683 7.492683 14.985366 0 4.995122-2.497561 9.990244-4.995122 12.487805l-2.497561 2.497561-107.395122 72.429268c-4.995122 2.497561-12.487805 4.995122-17.482927 0-4.995122-2.497561-7.492683-7.492683-9.990243-12.487805v-144.858536c2.497561-9.990244 7.492683-14.985366 12.487804-17.482927z" fill="#2488ef" p-id="3405"></path>
                              </svg>
                              <span>视频解析</span>
                            </div>
                            <div class="content" v-if="JSON.parse(analyzeItem.video_url_arr).length > 0">
                              <div style="margin-top:20px;" v-for="(videoItemUrl, videoIndex) in JSON.parse(
                          analyzeItem.video_url_arr
                        )" :key="videoIndex">
                                <video :src="videoItemUrl" controls="controls" controlslist="nodownload"></video>
                              </div>
                            </div>
                          </div>
                          <!-- <div style="margin-top:10px" v-html="content.content"></div> -->

                          <div v-if="analyzeItem.video_url_arr">
                            <el-divider v-if="JSON.parse(analyzeItem.video_url_arr).length > 0"></el-divider>
                          </div>

                          <mavon-editor :style="{ 'min-height': '0px' }" preview-background="transparent" v-model="analyzeItem.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                        </div>
                      </div>
                    </div>
                  </el-drawer>
                </template>
                <template v-else>
                  <span v-if="props.row.show_type === 1" class="analysis_content" v-html="props.row.analysis"></span>
                  <span v-else class="analysis_content">
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                </template>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="left" width="50" label="编号" prop="sort_num">
        </el-table-column>

        <el-table-column align="left" label="题型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">单选题</span>
            <span v-else-if="scope.row.type == 2">多选题</span>
            <span v-else-if="scope.row.type == 3">判断题</span>
            <span v-else-if="scope.row.type == 4">填空题</span>
            <span v-else-if="scope.row.type == 5">简答题</span>
            <span v-else-if="scope.row.type == 6">综合题</span>
            <span v-else-if="scope.row.type == 9">编程题</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="题目" prop="title_str">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.title_str" placement="top-start">
              <span style="
                  max-width: 150px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                ">{{ scope.row.title_str }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="答案">
          <template slot-scope="scope">
            <span v-if="
                scope.row.type == '1' ||
                  scope.row.type == '2' ||
                  scope.row.type == '3'
              ">{{ scope.row.answer }}</span>
            <span v-else-if="scope.row.type == '4'">填空题答案</span>
            <span v-else-if="scope.row.type == '5'">简答题答案</span>
            <span v-else-if="scope.row.type == '6'">综合题答案</span>
            <span v-else-if="scope.row.type == '9'">
              <!-- 编程题答案 -->
              --
            </span>
          </template>
          <span></span>
        </el-table-column>

        <el-table-column align="center" width="150" label="创建时间" prop="created_time">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-link class="question_btn" type="primary" @click="EditQuestion(scope.row)">编辑</el-link>
            <el-link class="question_btn" type="primary" @click="deleteSchoolQuestion(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" layout="total, prev, pager, next" :page-size="page_size" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getSchoolQuestionList, deleteSchoolQuestion, tchGetOjProblemAnalysisList } from '@/api/educational'
// import Prism from "prismjs"; //引入插件
import 'prismjs/themes/prism-twilight.css' // you can change
import getcode from '@/config/getCodesStyle'

export default {
  //   name: 'CommonExam-Questionlist',
  data() {
    return {
      form: {
        question_title: '',
        type: '',
      },
      title: '',
      questionlist: [],
      bank_id: '',
      page_no: 1,
      page_size: 20,
      total: 0,

      programmingProblemShow: false,
      problemItem: null,
      analyzeList: [],
      analyzeItem: null,
      analyzePage: {
        page_no: 1,
        page_size: 10,
        total: 0
      },
    }
  },
  mounted() {
    this.title = this.$route.query.title
    this.bank_id = this.$route.query.id

    this.getSchoolQuestionList()
  },

  methods: {
    async handleProgrammingProblemDrawer(show, item = null) {
      if (item) {
        console.log(item)
        this.problemItem = item;
        const rs = await this.getTchGetOjProblemAnalysisList();
        if (!rs) {
          return this.$message.warning('暂无解析')
        }
      } else {
        this.problemItem = null
      }
      if (!show) {
        this.analyzeList = [];
        this.analyzeItem = null;
      }
      this.programmingProblemShow = show;
    },
    getTchGetOjProblemAnalysisList() {
      return tchGetOjProblemAnalysisList({
        language: 'all',
        title: '',
        problem_id: this.problemItem.oj_problem_id,
        isOwn: 0, // 0:全部 1:我的
        page_no: this.analyzePage.page_no,
        page_size: this.analyzePage.page_size,
      }).then(res => {
        this.analyzeList = res.ojProblemAnalysisList;
        this.analyzePage = {
          page_no: res.page_no,
          page_size: res.page_size,
          total: res.total
        }
        if (this.analyzeList.join('') !== '') {
          this.analyzeItem = this.analyzeList[0]
          return true;
        } else {
          return false;
        }
      })
    },
    handleChangePage(page) {
      this.analyzePage.page_no = page;
      this.getTchGetOjProblemAnalysisList()
    },
    handleSelectedAnalyzeItem(item) {
      this.analyzeItem = item;
    },

    AddQuestion() {
      console.log('添加试题')
      this.$router.push({
        name: 'CommonExam-AddQuestion',
        query: {
          id: this.$route.query.id,
          title: this.$route.query.title,
          subject_id: this.$route.query.subject_id,
          question_num: this.total,
          tpye: '2',
        },
      })
    },
    expandChange(row) {
      console.log(1212)
      console.log(row, 4512)
      setTimeout(() => {
        this.$nextTick(() => {
          getcode()
        })
      }, 100)
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getSchoolQuestionList()
    },
    EditQuestion(row) {
      console.log('编辑题目')
      console.log(row)
      // name: 'CommonExam-AddQuestion',
      //   query: {
      //     id: this.$route.query.id,
      //     title: this.$route.query.title,
      //     subject_id: this.$route.query.subject_id,
      //     question_num: this.total,
      //     tpye: '2',
      //   },
      this.$router.push({
        // name: 'add-question',
        name: 'CommonExam-AddQuestion',
        query: {
          id: this.bank_id,
          title: this.title,
          subject_id: row.subject_id,
          tpye: '3',
        },
        params: {
          question: row,
        },
      })
      sessionStorage.setItem('ExamData', JSON.stringify(row))
    },

    deleteSchoolQuestion(id) {
      console.log('删除题目')
      console.log(id)

      this.$confirm('确定删除本道题吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteSchoolQuestion({
          questionId: id,
        }).then((res) => {
          console.log('删除题目')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.getSchoolQuestionList()
          }
        })
      })
    },

    getSchoolQuestionList() {
      getSchoolQuestionList({
        questionBankId: this.bank_id,
        title_str: this.form.question_title,
        type: this.form.type,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('题目列表')
        console.log(res)
        this.total = res.total
        this.questionlist = res.questionList
        res.questionList.map((item) => {
          if (item.show_type === 2) {
            this.$nextTick(() => {
              getcode()
            })
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;

  .header {
    margin-top: 20px;

    .search {
      width: 250px;
    }

    .search_btn {
      margin-left: 20px;
    }
  }

  .questions {
    .question_title {
      font-weight: bold;
      font-size: 16px;
    }

    .options {
      margin-top: 20px;
      float: left;
      width: 100%;

      .options_title {
        float: left;
      }

      .options_content {
        float: left;
      }
    }

    .answer {
      margin-top: 20px;
      float: left;
      width: 50%;

      .answer_label {
        font-weight: bold;
      }

      .answer_content {
        margin-left: 10px;
        color: green;
        font-weight: bold;
      }
    }

    .analysis {
      margin-top: 20px;
      float: left;
      width: 50%;

      .analysis_label {
        font-weight: bold;
      }

      .analysis_content {
      }
    }

    .question_btn {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}

/deep/ .hljs {
  background: transparent;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}

/deep/.markdown-body code {
  font-size: 18px;
}
.el-drawer__body {
  .analyze-content,
  .codemirror-info-container {
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background: #f1f1f1;
      /*可以设置轨道颜色*/
      padding-right: 2px;
    }

    /*滚动条*/
    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #f1f7fe;
    .analyze-header,
    .codemirror-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 15px 30px;
      background-color: #1878ff;
    }
    .analyze-body {
      display: flex;
      height: 100%;
      padding: 20px;
      overflow: hidden;
      .analyze-left {
        width: 50%;
        padding: 15px;
        margin-right: 10px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 5px;
        .analyze-left-item {
          padding: 15px;
          border-bottom: 1px solid #f0f3f9;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.25s;
          &:hover {
            background-color: #efefef;
          }
          &.active {
            .title {
              strong {
                color: #409eff;
              }
            }
          }
          .title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              width: 50px;
              margin-right: 20px;
              border-radius: 10px;
            }
            strong {
              margin-right: 20px;
              color: #000;
              font-size: 18px;
            }
          }
          .content {
            overflow: hidden;
            text-overflow: ellipsis;
            /* 超出部分省略号 */
            word-break: break-all;
            /* break-all(允许在单词内换行。) */
            display: -webkit-box;
            /* 对象作为伸缩盒子模型显示 */
            -webkit-box-orient: vertical;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2;
            /* 显示的行数 */
            line-height: 30px;
          }
        }
        .pagination {
          padding: 10px 0;
          text-align: right;
        }
      }
      .analyze-right {
        width: 50%;
        padding: 15px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 5px;
        .title {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: bold;
        }
        .stu-info {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            width: 50px;
            margin-right: 10px;
            border-radius: 10px;
          }
          span {
            margin-right: 15px;
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background: #f1f1f1;
  /*可以设置轨道颜色*/
  padding-right: 2px;
}

/*滚动条*/
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}
</style>
